<template>
    <div>
        <a-page-header style="border: 1px solid rgb(235, 237, 240)" :ghost="false" title="Sesi Kelas">
            <common-training-header/>
        </a-page-header>

        <a-row type="flex" style="margin-bottom: 12px">
            <a-col :flex="5">
                <a-card>
                    <strong>Kelas: </strong>
                    <a-form-item>
                        <a-select
                            v-model="classes_id"
                            style="width: 200px"
                            @change="handleChange">
                            <a-select-option
                                v-for="d in classes"
                                :key="d.id"
                                :value="d.id"
                            >
                                {{ d.name }}
                            </a-select-option>
                        </a-select>
                    </a-form-item>
                </a-card>
            </a-col>
        </a-row>

        <a-row type="flex" style="margin-bottom: 12px">
            <a-col  style="padding-left: 12px" flex="1 1 200px"></a-col>
            <a-col flex="0 1 300px">
                <a-button
                    type="primary"
                    icon="plus"
                    block
                    :href="routeUri('admin.classical.class.sessions.create', {
                        classes: classes_id
                })"> Tambah Sesi</a-button>
            </a-col>
        </a-row>

        <a-card type="inner" size="small">
            <a-table
                class="pcp-table"
                :dataSource="items.sessions"
                rowKey="id"
                :loading="loading"
                :pagination="false"
                bordered>

                <a-table-column key="name" title="Nama" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.name }}
                    </template>
                </a-table-column>

                <a-table-column key="material" title="Materi" className="align-center text-small text-left">
                    <template slot-scope="record">
                        {{ record.material.name }}
                    </template>
                </a-table-column>

                <a-table-column key="inspirator" title="Inspirator" className="align-center text-small text-center">
                    <template slot-scope="record">
                        {{ record.inspirator.name }}
                    </template>
                </a-table-column>

                <a-table-column key="session_schedule" title="Jadwal Sesi" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-tooltip>
                            <template slot="title">
                            Sesi dimulai
                            </template>
                            <a-icon type="calendar" /> {{ moment(record.session_time_start).format('DD MMMM YYYY HH:mm:ss') }}
                        </a-tooltip>
                        <br />
                        s/d
                        <br />
                        <a-tooltip>
                            <template slot="title">
                            Sesi berakhir
                            </template>
                            <a-icon type="calendar" /> {{ moment(record.session_time_end).format('DD MMMM YYYY HH:mm:ss') }}
                        </a-tooltip>
                    </template>
                </a-table-column>

                <a-table-column key="exam_schedule" title="Jadwal Ujian" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-icon type="calendar" theme="filled" />
                        <strong> {{ moment(record.exam_time_start).format('DD MMMM YYYY HH:mm:ss') }} </strong> <br/>
                        <a-tooltip>
                            <template slot="title">
                                Durasi {{ record.exam_duration }} Menit
                            </template>
                            <a-icon type="clock-circle" theme="twoTone" /> {{ record.exam_duration }} Menit
                        </a-tooltip>
                    </template>
                </a-table-column>

                <a-table-column key="remid_schedule" title="Jadwal remid" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-icon type="calendar" theme="filled" />
                        <strong> {{ moment(record.remid_time_start).format('DD MMMM YYYY HH:mm:ss') }} </strong>
                    </template>
                </a-table-column>

                <a-table-column key="exam_session" title="Soal Ujian" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-icon type="close-circle" theme="twoTone" two-tone-color="#f54242" v-if="record.class_exam_count == 0" />
                        <a-icon type="check-circle" v-else theme="twoTone" two-tone-color="#52c41a"/>
                    </template>
                </a-table-column>

                <a-table-column key="action" title="Action" className="align-center text-small text-center">
                    <template slot-scope="record">
                        <a-space>
                            <a-tooltip title="Edit Sesi Kelas">
                                <a-button
                                    size="small"
                                    type="primary"
                                    icon="edit"
                                    @click="showModal(record.id)"
                                />
                            </a-tooltip>
                        </a-space>
                    </template>
                </a-table-column>
            </a-table>

            <a-modal
                :destroyOnClose="true"
                :footer="null"
                :visible="visible"
                :closable="false"
                width="50%"
            >
                <class-session-form
                    :session_id="this.session_id"
                    :class_obj="this.classes[0]"
                    @handleClose="closeModal"
                />
            </a-modal>
        </a-card>
    </div>
</template>

<script>
export default {
    data() {
        return {
            form: this.$form.createForm(this),
            loading: false,
            items: {},
            session_id: null,
            visible: false,
            classes: [],
            filters: {
                q: null,
                page: 1,
                class_type: "class"
            },
            classes_id: null
        }
    },
    created() {
        this.getClasses()
        this.items = this.getDefaultPagination()
        this.filters = _.merge(this.filters, this.$laravel.request)
    },
    methods: {
        getItems(id) {
            this.loading = true

            this.$http
                .get(this.routeUri('api.classical-session'), {
                    params: {
                        class: id
                    }
                })
                .then((response) => (this.items = response.data))
                .catch((error) => this.handleXhrError(error))
                .finally(() => (this.loading = false))
        },
        getClasses() {
            this.loading = true

            this.$http
                .get(this.routeUri('api.training-classes'))
                .then(response => {
                    this.classes = response.data.classess
                    this.getItems(this.classes[0].id)
                    this.classes_id = this.classes.length >= 1 ? this.classes[0].id : 0
                })
                .catch(error => this.handleXhrError(error));
        },
        handleChange(value) {
            this.classes_id = value
            this.getItems(value)
        },
        handleSubmit(e) {
            e.preventDefault()

            this.pushState(this.filters)
            this.getItems()
        },
        handleReset(e) {
            e.preventDefault()

            this.filters = {
                q: null,
                page: 1,
            }
        },
        tableChanged(pagination) {
            this.filters.page = pagination.current
            this.pushState(this.filters)
            this.getItems()
        },
        showModal(hash) {
            this.session_id = hash.toString()
            this.visible = true
        },
        closeModal(isRefresh) {
            this.visible = false

            if (isRefresh == true) {
                this.getItems()
            }
        }
    },
    watch: {
        classes: function(value) {
            this.classes_id = value[0].id
        }
    }
}
</script>
